/**
 * The width of the side panel in rem
 */
export const GRAPH_SIDE_PANEL_WIDTH_REM = 42;
